

import {
    Column,
    Row,
    Spacer,
    Text
} from '@components/1-atoms';
import ListItem, { Props as ListItemProps } from '@components/2-molecules/ListItem';
import styled, { css } from '@emotion/native';
import setTheme from '@lib/theme';
import React, { FC } from 'react';

import DefaultCheckedIcon from '@assets/icons/checked';
import DefaultUncheckedIcon from '@assets/icons/unchecked';


import ModuleIcon from '@assets/icons/modules/documents';
import { FlatListProps, Platform, View } from 'react-native';
const FlatList = styled.FlatList`` as React.ComponentType<any>;

import * as utils from '@lib/utils';



export type Props = {
    data: any[];
    defaultValue?: any;
    onPress?: (data: any) => void;
} & ListItemProps & Omit<FlatListProps<ListItemProps>, 'renderItem'>;

const theme = setTheme('light');

const SubscriptionList: FC<Props> = ({ data, defaultValue, onPress, ...props }) => {

    const _renderItem = ({ item }: any) => {

        const { name, description } = item;

        const isSelected = utils.deepEqual(defaultValue, item) && <DefaultCheckedIcon />;

        const right = isSelected ? <DefaultCheckedIcon /> : <DefaultUncheckedIcon />;

        return (
            <ListItem
                {...props}
                sub={<Text small color={"#808080"}>{description}</Text>}
                onPress={() => { onPress?.(item) }}
                right={right}
            >
                <Text color={theme.pallete.accentColor}>{name}</Text>
            </ListItem>
        );
    };

    {/* Empty list message box */ }
    if (data?.length === 0) {
        return (
            <View>
                <Spacer h={3} />
                <Row style={{ justifyContent: 'center' }}>
                    <ModuleIcon {...props} />
                </Row>
                <Spacer h={.9} />
                <Row>
                    <Column>
                        <Text align='center' {...props}>No subscription package available</Text>
                    </Column>
                </Row>
                <Spacer h={3} />
            </View>);
    } else {
        return (
            <View>
                <Spacer h={1} />

                {/* CASE 1: */}
                {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
                {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
                {/* is taller than the screen. */}

                {/* This SectionList is itself a scrollable view. */}
                {/* However, nested while not supported in react-native is supported in react-native-web */}

                {/* CASE 2: */}
                {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
                {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
                {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

                {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
                {/*               The view contains the list inside its immediate container.*/}
                <View style={css(`width: 100%; height: auto; `)}>
                    <FlatList
                        scrollEnabled={(Platform.OS === 'web') ? true : false}
                        data={data}
                        keyExtractor={(item: any, ind: number) => item && `${ind}`}
                        renderItem={_renderItem}
                    />
                </View>
            </View>
        );
    }

};

export default SubscriptionList;